import React, { useEffect, useState } from 'react';
import getValueOfAQueryParameter from '../../Util/QueryString';
import useFetch from '../../CustomHooks/useFetch';
import { getCookie } from '../../Util/Cookie';

export default function Payment__Configuration__Completed(props) {

    //const [code, setCode] = useState('');
    const [postAuthCodeResponse, postAuthCode] = useFetch();
    const [statusMessage, setStatusMessage] = useState('');


    useEffect(
        () => {
            console.log(props.location.search);
            let codeTemp = getValueOfAQueryParameter(props.location.search, 'code');
            //setCode (codeTemp);

            postAuthCode(
                {
                    url: '/admin/stripe/connect',
                    method: 'POST',
                    headers: [{ name: 'Authorization', value: 'Bearer ' + getCookie('token') }],
                    postData: {
                        authorizationCode: codeTemp,
                    },
                }
            )


        }
        , []
    )

    useEffect(
        () => {
          //window.gtag('config', 'UA-160225157-2', {'page_path': '/PaymentConfiguration__Completed'});
        }, []
      )

    useEffect(
        () => {

            console.log(postAuthCodeResponse);
            console.log(postAuthCodeResponse.failMessage);
            if (postAuthCodeResponse.length != 0 && postAuthCodeResponse) {
                setStatusMessage('Congratulations! You have successfully connected your stripe account with Happy Table. Now you are ready to accept orders :)');
            }

            if (postAuthCodeResponse.length != 0 && postAuthCodeResponse == false) {
                setStatusMessage('There was a problem. Please try again or contact support');
            }


        }, [postAuthCodeResponse]
    )



    return (
        <div className="status-message-div" style={{ textAlign: 'center', marginTop: '30px' }}>
            {statusMessage}
        </div>
    )
}